import { render, staticRenderFns } from "./DataExtension.vue?vue&type=template&id=21dd7d5b&scoped=true&"
import script from "./DataExtension.vue?vue&type=script&lang=js&"
export * from "./DataExtension.vue?vue&type=script&lang=js&"
import style0 from "./DataExtension.vue?vue&type=style&index=0&id=21dd7d5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dd7d5b",
  null
  
)

export default component.exports